import type { MotorP } from "../../tip";

/**
 * Türkçe sözlük · motor mesajları · olcu. Anahtar motorun `mm("kod", …)`
 * çağrısındaki koddur; değer, mesajın değerlerinden cümleyi kurar.
 */
export const olcu = {
  // sepet dağılımı (sepetDagilimi.ts) — dışarıda kalanın sebebi
  "olcu.sepetElleDegerlenen": () => "elle değerlenen",
  "olcu.sepetListedeYok": () => "listede yok ya da hazırlanıyor",
  "olcu.sepetDegerOlculemedi": () => "değeri ölçülemedi",
  "olcu.sepetDegerSifir": () => "değeri sıfır",
  "olcu.sepetIlkDisinda": (p: MotorP) => `ilk ${p.sayi} dışında`,

  // günlük seri (series.ts)
  "olcu.toplamDegerYok": () => "Toplam değer yok.",
  "olcu.toplamMaliyetYok": () => "Toplam maliyet yok.",
  "olcu.kazancToplamiYok": () => "Kazanç toplamı yok.",
  "olcu.maliyetSifirOranYok": () => "Maliyet sıfır: oran yok.",
  "olcu.getiriYok": () => "Getiri yok.",

  // getiri özeti (getiriOzeti.ts)
  "olcu.adGetiri": () => "getiri",
  "olcu.adPortfoyDegeri": () => "portföy değeri",
  "olcu.gunIcinHesaplanmamis": (p: MotorP) => `${p.gun} için ${p.ad} hesaplanmamış.`,
  "olcu.gunAlanOlculemedi": (p: MotorP) => `${p.gun} ${p.ad}: ${p.sebep}`,
  "olcu.motorSebepSoylemediAra": () => "motor sebebini söylemedi",
  "olcu.motorSebepSoylemedi": () => "Motor sebebini söylemedi.",
  "olcu.seriBos": () => "Seri boş.",
  "olcu.dunEldeVarlikYok": () => "Dün elde varlık yoktu; günlük oran yok.",
  "olcu.sonYilEldeVarlikYok": () => "Son bir yılda elde varlık yoktu; oran yok.",

  // ölçüler (olculer.ts)
  "olcu.gunHesaplanmamis": (p: MotorP) => `${p.gun} hesaplanmamış.`,
  "olcu.gunDegeriOlculemedi": (p: MotorP) => `${p.gun} değeri ölçülemedi.`,
  "olcu.gunGetirisiOlculemedi": (p: MotorP) => `${p.gun} getirisi ölçülemedi.`,
  "olcu.enAzIkiGun": () => "Ölçü için en az iki gün gerekir.",
  "olcu.eldeVarlikOlanGunYok": () => "Aralıkta elde varlık olan gün yok.",
  "olcu.olculemeyenGunler": (p: MotorP) => `${p.sayi} gün ölçülemedi (ilki: ${p.ilk}); o günler atlandı.`,
  "olcu.dususYok": () => "Aralıkta düşüş olmadı.",
  "olcu.olculmusYilYok": () => "Ölçülmüş yıl yok.",
  "olcu.olculmusAyYok": () => "Ölçülmüş ay yok.",
  "olcu.oynaklikEnAzGun": (p: MotorP) => `Oynaklık için en az ${p.sayi} ölçülmüş gün gerekir.`,
  "olcu.kiyasSecilmedi": () => "Kıyas serisi seçilmedi.",
  "olcu.araligGetirisiYok": () => "Aralığın getirisi yok.",
  "olcu.kiyasGetirisiOlculemedi": () => "Kıyas serisinin getirisi ölçülemedi.",
  // kıyas serisinin değeri (db.worker.ts `olculer`, KiyasSonucu.neden)
  "olcu.kiyasFiyatYok": (p: MotorP) => `${p.tarih} için kıyas fiyatı yok.`,
  "olcu.kiyasKurYok": (p: MotorP) => `${p.tarih} için ${p.base}/${p.quote} kuru yok.`,
  "olcu.kiyasBaslangicSifir": () => "Kıyasın başlangıç değeri sıfır.",

  // dönemsel getiri (donemsel.ts)
  "olcu.kaynaktaFiyatYok": () => "Bu tarih için kaynakta fiyat yok.",
  "olcu.fiyatIndirilmedi": () => "Bu tarih için fiyat henüz indirilmedi.",
  "olcu.aracTuruBilinmiyor": () => "Aracın türü bilinmiyor; temettü ödeyip ödemediği söylenemez.",
  "olcu.aracTemettuBilgisiYok": () => "Bu araç için temettü bilgisi yok; temettülü getiri hesaplanamıyor.",
  "olcu.tarihTemettuBilgisiYok": () => "Bu tarih için temettü bilgisi yok; temettülü getiri hesaplanamıyor.",
  "olcu.temettuTutariYok": (p: MotorP) => `${p.tarih} tarihli temettünün tutarı kaynakta yok.`,
  "olcu.temettuGunuFiyatYok": (p: MotorP) => `${p.tarih} temettüsü günündeki fiyat yok.`,
  "olcu.temettuKurYok": (p: MotorP) => `${p.tarih} temettüsü için ${p.base}/${p.quote} kuru yok.`,
  "olcu.temettuGunuFiyatSifir": (p: MotorP) => `${p.tarih} temettüsü günündeki fiyat sıfır.`,
  "olcu.aracParaBirimiBilinmiyor": () => "Aracın para birimi bilinmiyor.",
  "olcu.temettuIslenemedi": (p: MotorP) => `Temettü işlenemedi: ${p.sebep}`,
  "olcu.kurYok": (p: MotorP) => `${p.base}/${p.quote} kuru yok.`,
  "olcu.periyotBasiVeriOncesi": (p: MotorP) =>
    `Periyodun başı (${p.gun} gün önce) verinin başladığı ${p.ilkVeri} tarihinden önce.`,
  "olcu.periyotBasiDegerYok": (p: MotorP) => `Periyodun başında (${p.gun} gün önce) değer yok: ${p.sebep}`,
  "olcu.periyotBasiDegerSifir": () => "Periyodun başında değer sıfır; oran yok.",
  "olcu.degerYok": () => "Değer yok.",
  "olcu.degerYokAra": () => "değer yok.",
  "olcu.araliktaHicDegerYok": (p: MotorP) => `Bu aralıkta hiç değer yok: ${p.sebep}`,
  "olcu.veriBasliyor": (p: MotorP) => `Veri ${p.tarih} tarihinde başlıyor.`,
  "olcu.sepetKurulmadi": () => "Sepet henüz kurulmadı.",
  "olcu.sepetVarlikDegerYok": (p: MotorP) => `Sepetteki bir varlığın değeri yok: ${p.sebep}`,
  "olcu.ortalamaIcinGunYok": (p: MotorP) => `Ortalama için ${p.sayi} işlem günü henüz yok.`,
  "olcu.sepetVerisizVarliklar": (p: MotorP) => `Şu varlıkların bu aralıkta hiç değeri yok: ${p.varliklar}.`,
  "olcu.temettuTutarlariYokNot": (p: MotorP) =>
    `${p.tarihler} tarihli temettünün tutarı kaynakta yok; o tarihi kapsayan getiriler hesaplanmadı.`,
} satisfies Record<string, (p: MotorP) => string>;
